import { render, staticRenderFns } from "./RequireAddress.vue?vue&type=template&id=1b9eb110&"
import script from "./RequireAddress.vue?vue&type=script&lang=js&"
export * from "./RequireAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports